import React from 'react';
import { confirmable, createConfirmation } from 'react-confirm';
import BasicButton from '../../../../components/BasicButton';
import BasicButtonGroup from '../../../../components/BasicButtonGroup';
import Popup from '../../../../components/Popup';
import UxHelpers from '../../../../helpers/ux-helpers';
import Dialog from '../../index';

const ConfirmYourProfile = props => {
  const { show, dismiss } = props;

  const dismissHandler = () => {
    dismiss();
    UxHelpers.overflowLock('unlock');
  };

  const buttons = (
    <BasicButtonGroup
      groupStyles={{
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <BasicButton
        controlFunc={dismissHandler}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText={'ОК'}
      />
    </BasicButtonGroup>
  );

  const body = (
    <Dialog>
      <div style={{ textAlign: 'center' }}>
        Your account is awaiting approval – this will take 1-2 business days.<br />
        In the meantime please check your email to confirm your account.
      </div>
    </Dialog>
  );

  return (
    show && (
      <Popup
        actions={{
          dismiss,
        }}
        buttonsRender={buttons}
        bodyRender={body}
      />
    )
  );
};

export default createConfirmation(confirmable(ConfirmYourProfile));
